import { SignupStep } from "pages/files/Signup";
import { CustomComponentProps } from "utils/types/generalTypes";

export type SignupTitleProps = CustomComponentProps & {
    steps: SignupStep[];
    currentStep: number;
};

const SignupTitle = ({
    steps,
    currentStep,
    className,
    style
}: SignupTitleProps) => {
    return (
        <div className={`process-title ${className}`} style={style}>
            {steps.map((step, index) => (
                <h2
                    key={step.id}
                    className={`step-title ${currentStep == index ? "is-active" : ""}`}
                >
                    {step.title}
                </h2>
            ))}

            {/* <h2 id="step-title-2" className="step-title">
                Verify Your Email.
            </h2>
            <h2 id="step-title-3" className="step-title">
                More About You.
            </h2>
            <h2 id="step-title-4" className="step-title">
                Select Your Topics Prefrence.
            </h2>
            <h2 id="step-title-5" className="step-title">
                Follow other users.
            </h2>
            <h2 id="step-title-6" className="step-title">
                Secure Your Account.
            </h2>
            <h2 id="step-title-7" className="step-title">
                You're all set. Ready?
            </h2> */}
        </div>
    );
};

export default SignupTitle;
